'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function HomepageNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-card/95 backdrop-blur-md border-b border-border card-shadow' : 'bg-transparent'}`}>
      <div className="max-w-screen-xl mx-auto px-4 lg:px-8">
        <div className="flex items-center h-16 gap-8">
          <Link href="/" className="flex items-center gap-2">
            <AppLogo size={32} />
            <span className={`font-bold text-xl ${scrolled ? 'text-foreground' : 'text-white'}`}>EzCleanCare</span>
          </Link>

          <div className="hidden md:flex items-center gap-6 flex-1">
            {['Services', 'How It Works', 'Pricing', 'Reviews']?.map((item) => (
              <a
                key={`nav-${item}`}
                href={`#${item?.toLowerCase()?.replace(/\s+/g, '-')}`}
                className={`text-sm font-medium transition-colors hover:text-accent ${scrolled ? 'text-muted-foreground' : 'text-white/80'}`}
              >
                {item}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3 ml-auto">
            <Link
              href="/sign-up-login-screen"
              className={`text-sm font-semibold px-4 py-2 rounded-xl transition-all duration-150 hover:opacity-80 ${scrolled ? 'text-foreground' : 'text-white'}`}
            >
              Sign In
            </Link>
            <Link
              href="/booking-flow"
              className="text-sm font-semibold px-4 py-2 rounded-xl gradient-primary text-white hover:opacity-90 active:scale-95 transition-all duration-150"
            >
              Book a Cleaning
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden ml-auto p-2 rounded-lg ${scrolled ? 'text-foreground' : 'text-white'}`}
            aria-label="Toggle mobile menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-card border-t border-border animate-slide-up">
          <div className="px-4 py-4 space-y-2">
            {['Services', 'How It Works', 'Pricing', 'Reviews']?.map((item) => (
              <a
                key={`mobile-nav-${item}`}
                href={`#${item?.toLowerCase()?.replace(/\s+/g, '-')}`}
                className="block text-sm font-medium text-muted-foreground py-2.5 px-3 rounded-xl hover:bg-muted"
                onClick={() => setMobileOpen(false)}
              >
                {item}
              </a>
            ))}
            <div className="pt-2 flex flex-col gap-2">
              <Link href="/sign-up-login-screen" className="text-center text-sm font-semibold py-2.5 px-4 rounded-xl border border-border text-foreground hover:bg-muted transition-colors">
                Sign In
              </Link>
              <Link href="/booking-flow" className="text-center text-sm font-semibold py-2.5 px-4 rounded-xl gradient-primary text-white">
                Book a Cleaning
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}